<template>
  <div class="wrapper col-8">
    <div class="animated fadeIn">
      <b-card
        header-tag="header"
        footer-tag="footer">
        <div slot="header">
          <i class="fa fa-bell-o"></i> Air Movement
          <div class="card-header-actions">
                <b-button type="button" size="sm" variant="primary" @click="mofaEventHandler">
                  <i class="fa fa-edit"></i> MoFA
                </b-button>
          </div>
        </div>
           <br>
           <form>
              <b-row>
                <b-col class="col-12"><h5>Purpose<span class="required">*</span></h5></b-col><br>
              </b-row>
              <b-row>                
                <b-col class="col-4">
                  <b-form-group class="required">
                    <b-form-select 
                       v-if="purposeList"
                       type="text" placeholder="Mission Purpose" 
                       text-field="description" 
                       value-field="id"
                       :options="purposeList"
                       :value="purposeId"
                       @change="purposeChangeEventHandler">
                       <template slot="first">
                          <option :value="null" disabled>-- Please select an option --</option>
                      </template>
                    </b-form-select>
                    <small class="text-danger font-weight-bold">{{ validation.firstError('purposeId') }}</small>
                  </b-form-group>
                </b-col>
                <b-col class="col-4" v-if="isOtherPurpose">
                  <b-form-group class="required" :class="{error: validation.hasError('purposeOthers')}">
                      <b-form-input ref="purposeOthers" v-model="purposeOthers" placeholder="Enter other purpose" @keyup.native="changeEventHandler"></b-form-input></b-form-input>
                      <small class="text-danger font-weight-bold">{{ validation.firstError('purposeOthers') }}</small>
                  </b-form-group>  
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                    <h5>Upload Documents</h5>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="7"> 
                    <b-alert :show="showUploadAlert"
                             dismissible
                             variant="warning">
                        <strong>Upload completed!</strong> You successfully upload the file.
                    </b-alert>
                    <b-alert :show="showUploadError"
                           dismissible
                           variant="danger">
                        <strong>Upload Error!</strong> File size must not exceed 1MB in size.
                    </b-alert>
                    <b-form-group>
                       <file-upload
                            ref='fileUpload'
                            title=""
                            accept=".pdf"
                            @event-handler="fileUploadEventHandler($event)">            
                          </file-upload> 
                    </b-form-group>
                </b-col>
                
                <b-col sm="5"> 
                    <b-form-group>
                      <label>Upload the following documents:</label>
                       <ul>      
                          <li>GACA</li>                    
                          <li>Pax Manifest </li>
                          <li>Passport copies and Visas' copies</li>
                          <li>Cargo documents</li>
                          <li>Packing lists</li>
                          <li>Any other documents</li>
                       </ul>
                    </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                    <b-table style="background-color: #fff" hover="hover" small="small" striped="striped" bordered="bordered" responsive="sm" :items="attachments" :fields="fields" :current-page="currentPage" :per-page="perPage">
                       <template slot="date_uploaded" slot-scope="data">
                        {{data.item.date_uploaded | formatDate('DD/MM/YYYY HH:mm:ss')}} 
                      </template>
                      <template slot="action" slot-scope="data" style="width:10px">
                          <b-dropdown class="float-right" variant="transparent text-muted p-0" right no-caret>
                            <template slot="button-content">
                              <i class="icon-settings"></i>
                            </template>
                            <b-dropdown-item @click="uploadItemEventHandler(data.item)" v-b-modal.confirmAttachmentModal v-b-modal.modal-center> Delete</b-dropdown-item>
                            <b-dropdown-item @click="downloadEventHandler(data.item)"> Download</b-dropdown-item>                            
                          </b-dropdown>                
                      </template>
                    </b-table>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <nav> 
                    <b-pagination size="sm" :total-rows="getRowCount(attachments)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next"/>
                  </nav> 
                </b-col> 
              </b-row>
            </form>

          <!-- FOOTER -->  
          <div slot="footer" class="float-right">
            <b-button variant="primary" @click="submitEventHandler" :disabled="!this.modified"><i class="fa fa-save"></i> Save</b-button>&nbsp;
            <b-button variant="secondary" @click="closeEventHandler"> <i class="fa fa-times"></i> Close</b-button>
          </div>
          <!--// FOOTER -->

      </b-card>
    </div>

    <!--// MODAL MoFA -->   
    <b-modal title="Success" class="modal-primary" ref="confirmMofaModal" id="confirmMofaModal" @ok="mofaEventHandler" @cancel="close" ok-title="Next" cancel-title="Cancel" centered>
      <b-row>
        <b-col sm="2" class="text-center"><i class="fa fa-check-circle fa-3x text-success"></i> </b-col>
        <b-col sm="10"><p>You've successfully completed notification form.  Click <b>Next</b> to continue filling out MoFA form.</p>     </b-col>
      </b-row>        
    </b-modal>  
    <!--// MODAL MoFA -->

    <!--// MODAL Confirm Remove Attachment -->   
    <b-modal title="Confirm" class="modal-primary" id="confirmAttachmentModal" @ok="removeAttachmentEventHandler" ok-title="Yes" cancel-title="No" centered>
        <p class="my-4">Are you sure you want to remove this attachment?</p>     
    </b-modal>  
    <!--// MODAL Confirm Remove Attachment -->  

    <!--// MODAL Confirm Save -->   
     <b-modal title="Confirm" class="modal-primary" ref="confirmSaveModal" id="confirmSaveModal" @ok="confirmSaveEventHandler" @cancel="close" ok-title="Save" cancel-title="Cancel" centered>
        <p class="my-4">You have unsaved changes on this form.&nbsp;&nbsp;Do you want to Save or Cancel the changes?</p>     
    </b-modal>  
    <!--// MODAL Confirm Save -->

  </div>
</template>

<script>
import * as utils from '@/mixins/utils'
import * as constants from '@/store/constants'
import * as types from '@/store/types'

import CommonService from '@/api/CommonService'
import NotificationService from '@/api/NotificationService'
import AirService from '@/api/AirService'
import UploadService from '@/api/UploadService'

import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import FileUpload from '@/components/file-upload/FileUpload'
import toast from '@/mixins/toast'
import airMixin from '@/mixins/validators/Air-validators'
import commonMixin from '@/mixins/validators/Common-validators'

export default {
  mixins: [
    airMixin,
    commonMixin
  ],
  data () {
    return {      
      isOtherPurpose: false,
      showUploadAlert: false,
      showUploadError: false,
      isUploadReady: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      selectedAttachment: null,
      fields: [
        {label:'Id', key: 'id', sortable: true, class: 'sm="4"'},
        {label:'Upload Date', key: 'date_uploaded', sortable: true},
        {label:'Description', key: 'description', sortable: true},
        {label:'Filename', key: 'filename', sortable: true},        
        {key: 'action'}
      ],
      local: constants.DATE_LOCALE_EN
    }
  },
  computed: {    
    purposeOthers: {
        get() {
          return this.$store.state.purposeOthers
        },
        set(value) {
          this.$store.commit(types.MUTATE_PURPOSE_OTHERS, value)
        }
    },
  ...mapGetters({      
      notificationId: types.GET_NOTIFICATION_ID,
      air: types.GET_AIR,
      modified: types.GET_MODIFIED,
      mofaView: types.GET_VIEW_MOFA,
      attachments: types.GET_ATTACHMENTS,
      startDate: types.GET_START_DATE,
      purposeId: types.GET_PURPOSE_ID,
      purposeList: types.GET_PURPOSES
    })
  },
  methods: {

    changeEventHandler() {
      this.$store.commit(types.MUTATE_MODIFIED, true)
    },

    purposeChangeEventHandler (e) {
      this.isOtherPurpose = (e === constants.PURPOSE_OTHERS)
       
      if (this.isOtherPurpose) {
          setTimeout(function () {
                    this.$refs.purposeOthers.$el.focus()
                  }.bind(this), 300) 
      } else {
        this.$store.commit(types.MUTATE_PURPOSE_OTHERS, "")
      }
      this.$store.commit(types.MUTATE_PURPOSE_ID, e)
      this.$store.commit(types.MUTATE_MODIFIED, true)
    },

    mofaEventHandler() {

       const routeName = utils.findMofaNameById( this.$store.state.requestTypeId )
       const notificationId = this.$store.state.notificationId

       setTimeout(function () {
            this.$store.dispatch(types.ACTION_FIND_MOFA, {type: routeName , id:notificationId})
            this.$store.commit(types.MUTATE_VIEW_MOFA, false)
        }.bind(this), 600)
       
       // load MOFA form       
       this.$router.replace('/forms/'+ routeName +"-mofa")
    },

    save () {

        const $this = this
        let status = this.$_.find(this.$store.state.statusList, {id: constants.STATUS_INUSE});
        let notes = this.$moment(new Date()).format('DD/MM/YYYY HH:mm') +'\n'+ status.name

        const payload = {
              id : this.notificationId,
              status_id : constants.STATUS_INUSE,
              notes : notes,
              ehoc_ref: this.$store.state.ehocRef,
              last_updated_by: this.$store.state.userId
          }
        
          if (payload.id == 0) {
             // $this.$store.dispatch(types.ACTION_ADD_VENUES, payload)
             // alert("SAVE New Record")
          } 
          else {
              // UPDATE Notification Status
              NotificationService.updateNotificationStatus(payload).then( (response) => {

                  if (response) {
                      // UPDATE Venues
                     $this.$store.commit(types.MUTATE_MODIFIED, false)
                     toast.success( "Saved successfully") 

                      if ($this.$store.state.new_notification) {
                          setTimeout(function () {
                             $this.$refs.confirmMofaModal.show()
                          }.bind(this), 300)
                      } 
                  }
              })
          }

    },
  
    submitEventHandler () {

      const $this = this
      const fieldsMain = ['purposeId','purposeOthers']

      this.$validate(fieldsMain)
          .then(function(success) {

                if (success) {
                    let currentDate = $this.$moment().format('YYYY-MM-DDTHH:mm:ssZ')
                    let payload = {
                        id: $this.$store.state.notificationId,
                        agency_id: $this.$store.state.agencyId,
                        requested_date: currentDate,
                        request_type_id: constants.FORM_AIR,
                        requested_by: $this.$store.state.userId,
                        purpose_id:  $this.purposeId,
                        purpose_others:  $this.purposeOthers,
                        ehoc_ref: $this.$store.state.ehocRef,
                        notes: $this.$store.state.notes,
                        last_updated_by: $this.$store.state.userId,
                        last_update: currentDate,
                        status_id: constants.STATUS_INUSE
                      }

                      if ($this.$store.state.permission === constants.ADMIN) { 
                           payload.status_id = $this.$store.state.statusId
                      }
                      
                      if (payload.id == 0) {
                         // $this.$store.dispatch(types.ACTION_ADD_VENUES, payload)
                         // alert("SAVE New Record")
                      } 
                      else {

                          const notificationId = $this.$store.state.notificationId  
                          // UPDATE Notification
                          NotificationService.updateNotification(payload).then( (response) => {

                              if (response) {
                                  // Save Admin Letters
                                 $this.save()
                              }
                          })
                      }
                }
                else {
                    toast.error( "Please complete all required fields", "Error")
                }
      })
        
    },

    confirmSaveEventHandler() {
      
      if (this.$store.state.new_notification) {
            setTimeout(function () {
              this.$refs.confirmMofaModal.show()
            }.bind(this), 300)
       } 
       else {
          this.close()
       }
    },

    closeEventHandler () {
      if (this.modified) {
          this.$refs.confirmSaveModal.show()
      } 
      else {
          this.close()
      }
    },

    close() {
        this.$store.commit(types.MUTATE_RESET_STATE)
        this.$store.commit(types.MUTATE_VIEW_MOFA, false)
        if (this.$store.state.permission === constants.ADMIN) {
            this.$router.replace('/dashboard')
        }    
        else {
            this.$router.replace('/user-dashboard')
        }      
    },


    confirmSaveEventHandler() {
      
      if (this.$store.state.new_notification) {
            setTimeout(function () {
              this.$refs.confirmMofaModal.show()
            }.bind(this), 300)
       } 
       else {
          this.close()
       }
    },

    disabledDate (time) {
      var yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return time < yesterday
    },
    
    uploadItemEventHandler(item) {        
        this.selectedAttachment = item
    },

    downloadEventHandler(item) {
        CommonService.download(item).then( (resp) => {          
          
      })
    },

    removeAttachmentEventHandler() {
      let item = this.selectedAttachment;
      const payload = {
            id : item.id,
            notification_id: item.notification_id
        }

        UploadService.remove(payload).then( (response) => {
           this.$store.commit(types.MUTATE_ATTACHMENTS, response)
        })        
    },

    getRowCount (items) {
      return items.length
    },

    async fileUploadEventHandler(event) { 

      const notificationId = this.$store.state.notificationId
      const requestTypeId = this.$store.state.requestTypeId
      const category = "AIR_DOCUMENT"
      const $this = this
      this.showUploadError = false
      
      let file = event.file
      if (!file) return

      // let formData = new FormData()
      // for (var i = 0; i < file.length; i++) {

      //     // validate if file exceeds 1mb
      //     if (file[i].size >= constants.FILE_MAXIMUM_SIZE) {
      //         this.showUploadError = true
      //         this.fileNameWithError = file[i].name
      //         return
      //     }
      //     formData.append('file', file[i], file[i].name)  
      // }
      
       // validate if file exceeds 1mb
      if (file.size >= constants.FILE_MAXIMUM_SIZE) {
          this.showUploadError = true
          return
      }
      let formData = new FormData()
      formData.append('file', file, file.name)

      this.showUploadAlert = true
      
      await UploadService.upload(formData, notificationId, requestTypeId, category, event.description).then( (resp) => {
          if (resp.length > 0) {
              this.$store.commit(types.MUTATE_MODIFIED, true)
              this.isUploadReady = true 
              
              setTimeout(function () {
                  this.showUploadAlert = false
                  this.$refs.fileUpload.reset()
              }.bind(this), 3000)

              // get attachments
              CommonService.fetchAttachment(notificationId).then( (resp) => {
                this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
              })
          }          
      })
   }
  },

  components: {
    FileUpload
  },

  created() {
      const $this = this
      this.$store.dispatch(types.ACTION_FIND_PURPOSES, constants.FORM_ADMIN_LETTERS)

      // setTimeout(function () {          
      //      // get attachments
      //     if ($this.notificationId) {
      //        CommonService.fetchAttachment($this.notificationId).then( (resp) => {
      //           $this.$store.commit(types.MUTATE_ATTACHMENTS, resp)
      //         })   
      //     }

      //     // reset validation
      //     this.validation.reset()
      // }.bind(this), 300)
  },

  mounted() {
    
    this.$nextTick(function () {      
      setTimeout(function () {
         if (this.$store.state.purposeId === constants.PURPOSE_OTHERS) {
            this.isOtherPurpose = true
         }
         this.validation.reset()
      }.bind(this), 600)
      
    })
  }

}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.form-group.required label::after {
   margin-right: 2px;
   content:"*";
   color:red;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/Air.vue